import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import EditProfile from "../../components/editProfile/EditProfile";
import Favorites from "../../components/favorites/Favorites";
import Orders from "../../components/orders/Orders";
import Settings from "../../components/settings/Settings";
import SpecialOffers from "../../components/specialOffers/SpecialOffers";
// import Navbar from '../../components/navbar/Navbar';
// import Footer from "../../components/footer/Footer";
import ChangePassword from "../../components/changePassword/ChangePassword.tsx";
import { ToastContainer } from "react-toastify";
import OrderDetail from "../../components/orderDetail/OrderDetail.tsx";
import OrderRate from "../../components/orderRate/OrderRate.tsx";
import ProductReturn from "../../components/productReturn/ProductReturn.tsx";
import OfferDetail from "../../components/offerDetail/OfferDetail.tsx";
// import Header from "../../components/header/Header.tsx";

const Profile: React.FC = () => {
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <Header /> */}
      {/* <Navbar/> */}
      <div className="flex">
        <Sidebar className="w-[92px] md:w-[340px] " />
        <div className="flex-grow  w-[calc(100%-72px)] md:w-[calc(100%-340px)] h-[calc(100vh-160px)]">
          <Routes>
            <Route path="/" element={<Navigate to="edit" replace />} />
            <Route path="edit" element={<EditProfile />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="orders" element={<Orders />} />
            <Route path="settings" element={<Settings />} />
            <Route path="special" element={<SpecialOffers />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="order-detail" element={<OrderDetail />} />
            <Route path="order-rate" element={<OrderRate />} />
            <Route path="product-return" element={<ProductReturn />} />
            <Route path="special/:id" element={<OfferDetail />} />
          </Routes>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Profile;
